import { Typography } from '@material-ui/core';
import React from 'react';
import useStyles from './styles';
import Image from 'next/image';
import PolvoIcon from '../../../public/images/polvo.svg';
import useTranslation from 'hooks/useTranslation';
import Link from 'next/link';
// import { Container } from './styles';

const Follow: React.FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <div className={classes.follow}>
      <Image src={PolvoIcon} alt="Instasorteio" />
      <div className={classes.followText}>
        <span>{t('followUs')}</span>
        <strong>@instasorteioo</strong>
      </div>
      <Link passHref href="https://www.instagram.com/instasorteioo/">
        <button>{t('follow')}</button>
      </Link>
    </div>
  );
};

export default Follow;
